import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { axiosInstance } from '../../api/api';

type ChannelModalProps = {
  show: boolean;
  onClose: () => void;
  onSave: () => void;
};

function ChannelModal({ show, onClose, onSave }: ChannelModalProps): JSX.Element {
  const [values, setValues] = useState({
    name: '',
  });

  const [errors, setErrors] = useState({
    name: '',
  });
  const handleChange = (e: React.ChangeEvent<any>): void => {
    const { name, value } = e.target;
    setValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: '',
    }));
  };

  const handleSubmitForm = async (e: React.ChangeEvent<any>): Promise<void> => {
    e.preventDefault();

    if (!values.name) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        name: 'Name is required',
      }));
      return;
    }

    // Post data to channels endpoint
    const postData = {
      name: values.name,
    };

    await axiosInstance().post('/channels', postData);
    onSave();
    onClose();
  };

  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Create channel</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmitForm}>
          <Form.Group className="mb-3" controlId="name">
            <Form.Label>Name</Form.Label>
            <Form.Control
              type="text"
              name="name"
              value={values.name}
              onChange={handleChange}
              placeholder="Enter name"
            />
            {errors.name && <Form.Text className="text-danger">{errors.name}</Form.Text>}
          </Form.Group>

          <div className="d-grid gap-2 mt-4">
            <Button variant="primary" type="submit">
              Save
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
}

export default ChannelModal;
